import axiosInstance from '@/shared/api/axios';
import type {
  ApiParcelsAdminOwnerlessCheckGetResponse,
  ApiParcelsAdminPostBody,
  ApiParcelsAdminPutBody,
  ApiParcelsApprovePostBody,
  ApiParcelsApprovePostResponse,
  ApiParcelsGetItem,
  ApiParcelsListParams,
  ApiParcelsListResponse,
  ApiParcelsRejectPostBody,
  FulfillmentStatus,
} from '@/shared/types/api/parcels';

export const apiParcelsListGet = async (
  params: ApiParcelsListParams,
): Promise<ApiParcelsListResponse> => {
  const { data } = await axiosInstance.get<ApiParcelsListResponse>('/parcels', { params });
  return data;
};

export const apiParcelsDetailGet = async (id: string): Promise<ApiParcelsGetItem> => {
  const { data } = await axiosInstance.get<ApiParcelsGetItem>(`/parcels/${id}`);
  return data;
};

export const apiParcelsAdminPost = async (
  body: ApiParcelsAdminPostBody,
): Promise<ApiParcelsGetItem> => {
  const { data } = await axiosInstance.post<ApiParcelsGetItem>('/parcels/admin', body);
  return data;
};

export const apiParcelsAdminPut = async (
  id: string,
  body: ApiParcelsAdminPutBody,
): Promise<ApiParcelsGetItem> => {
  const { data } = await axiosInstance.put<ApiParcelsGetItem>(`/parcels/${id}`, body);
  return data;
};

export const apiParcelsDelete = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/parcels/${id}`);
};

export const apiParcelsApprovePost = async (
  id: string,
  body: ApiParcelsApprovePostBody = {},
): Promise<ApiParcelsApprovePostResponse> => {
  const { data } = await axiosInstance.post<ApiParcelsApprovePostResponse>(
    `/parcels/${id}/approve`,
    body,
  );
  return data;
};

export const apiParcelsRejectPost = async (
  id: string,
  body: ApiParcelsRejectPostBody = {},
): Promise<ApiParcelsGetItem> => {
  const { data } = await axiosInstance.post<ApiParcelsGetItem>(`/parcels/${id}/reject`, body);
  return data;
};

// Lightweight existence probe used by the admin parcel-create form's
// "Joʻnatishga tasdiqlangan" checkbox: fires on trek_id blur to decide
// whether the box is at the warehouse and the checkbox can be ticked.
export const apiAdminOwnerlessCheck = async (
  trekId: string,
): Promise<ApiParcelsAdminOwnerlessCheckGetResponse> => {
  const { data } = await axiosInstance.get<ApiParcelsAdminOwnerlessCheckGetResponse>(
    '/parcels/admin/ownerless-check',
    { params: { trek_id: trekId } },
  );
  return data;
};

// Staff escape hatch: arbitrarily move the parcel between any of the 7
// fulfillment_status enum values (e.g. revert SORTING -> IN_PROGRESS so the
// client can re-edit). Backed by ``POST /parcels/<id>/set-workflow-status``.
export const apiAdminParcelSetWorkflowStatus = async (
  id: string,
  workflow_status: FulfillmentStatus,
): Promise<ApiParcelsGetItem> => {
  const { data } = await axiosInstance.post<ApiParcelsGetItem>(
    `/parcels/${id}/set-workflow-status`,
    { workflow_status },
  );
  return data;
};
